import {SmartComponent} from "smart-component-js";
import $ from "jquery";
import GigyaManager from "../business/GigyaManager";
import RestManager from "../business/RestManager";
import moment from "moment";
import Constants from "../business/Constants";

class AreaPersonaleCtrl extends SmartComponent {

    constructor(element, parentComponent, params) {
        super(element, parentComponent, params);
        this.init();
    }
    init() {
        this.loadChildComponents(this);
        this.startLoader();

        if(moment(Constants.CLOSING_STEP_1_DATE, 'DD/MM/YYYY HH:mm').diff(moment()) < 0){
            $('.closingStep1').show();
        }else{
            $('.beforeClosing').show();
        }

        GigyaManager.getLoggedUserCached().then((u) => {
            let name = u.profile.firstName;
            let gender = u.profile.gender;
            let msg = $(".custom-msg");
            if (gender === "f"){
                $(msg).html("Benvenuta " + name);
            } else if (gender === "m") {
                $(msg).html("Benvenuto " + name);
            } else {
                $(msg).html("Ciao " + name);
            }

            RestManager.userStatus().then((data)=>{

                $('#receipt_number').html(data.response.data.contests[0].plays_stats.total);
                let plays = data.response.data.contests[0].plays;

                $('.recap-cnt').html("");

                let hasRequestPrize = false;

                for(var i = plays.length-1; i >= 0; i--){
                    $('.recap-cnt').append(this.buildReceiptTemplate(plays[i]));

                    if((plays[i].istant_win.win_status == 'WIN' || plays[i].istant_win.win_status == 'FINAL') && plays[i].istant_win.prize_request.requested > 0){
                        hasRequestPrize = true;
                    }
                }

                let win = data.response.data.contests[0].plays_stats.win;

                if(win.phone || win.web){
                    if(hasRequestPrize){
                        $('.edit-content').html('<p>Complimenti, hai vinto il Set completo "Il rito della colazione" e richiesto il tuo premio.<br/>Stiamo controllando la tua partecipazione e il tuo documento di acquisto. <br/>Appena effettuata la verifica il tuo premio sarà spedito all’indirizzo che ci hai comunicato. <br/>Per avere informazioni relative alla consegna consulta la sezione <a href="/promozioni/vinci-il-buongiorno/faq-e-contatti">Faq e Contatti</a>.</p>');
                    }else {
                        $('.edit-content').html('<p>Complimenti, hai vinto il Set completo "Il rito della colazione".<br/>Richiedi il tuo premio e compila tutti i campi necessari per la spedizione.</p>');

                    }
                }

                if(data.response.data.final_prize && !hasRequestPrize){

                    $('.edit-content').html(`
                        <p><strong>Il concorso è terminato.</strong></p>
                        <p><strong>Complimenti, hai vinto il Set completo "Il rito della colazione".</strong><br/>Richiedi il tuo premio e compila tutti i campi necessari per la spedizione.<br/><a href="/promozioni/vinci-il-buongiorno/completa-dati?pt=${data.response.data.final_prize_token}&pm=1">Richiedi Premio</a></p>
                    `);
                }

                this.removeLoader();
            }, (data)=>{
                this.removeLoader();
                console.log(data);
                let tmplModalGeneric = ` <div class="feedback__modal" component="FeedbackModalComponent">
                                                    <div class="feedback__modal__wrap">
                                                        <div class="feedback__modal__close" component-click="close()">
                                                            <svg>
                                                                <use xlink:href="#svg_circle_close"></use>
                                                            </svg>
                                                        </div>
                                                        <div class="feedback__modal__content">
                                                            <h2 class="h3">Ops, qualcosa è andato storto!</h2>
                                                            <p>${data.status.errors.description}</p>
                                                        </div>
                                                    </div>
                                                </div>
                                               `;
                $(this.element).append(tmplModalGeneric);
                this.loadChildComponents(this);
            })


        }, (err) => {
            window.location.href = "/login?urlBack="+window.location.href.replace(window.location.origin, "")+"&regSource="+Constants.PROMO_CODE;
        })
    }

    goToPlayReceipt(){
        //TODO Mettere blocco orario!
        window.location.href='/promozioni/vinci-il-buongiorno/gioca-scontrino'
    }

    buildReceiptTemplate(obj){

        let mm_play_date = moment(obj.istant_win.play_date, "YYYY-MM-DD hh:mm:ss");
        let mm_receipt_date = moment(`${obj.istant_win.receipt.receipt_year}-${obj.istant_win.receipt.receipt_month}-${obj.istant_win.receipt.receipt_day}`, 'YYYY-MM-DD');
        mm_play_date.locale('it');
        mm_receipt_date.locale('it');
        let html = `
            <div class="recap-row ${obj.istant_win.win_status == 'WIN' ? 'done' : '' }">
                <div class="recap-row-content">
                    <span class="recap-date">${mm_play_date.format('LL')}</span><br/>
                    Scontrino del <span class="recap-date-scontrino">${mm_receipt_date.format('LL')}</span><br/>
                    Totale &euro; <span class="recaptotal">${obj.istant_win.receipt.receipt_euros},${obj.istant_win.receipt.receipt_cents}</span>
                </div>
                ${this.printFeedback(obj)}
            </div>
        `;
        return html;
    }

    printFeedback(obj){
        let prizeRequestToDo = ` <span class="content-feedback col50">
            Hai vinto il Set completo il rito della colazione
        </span>
        <a class="button more-padding" href="/promozioni/vinci-il-buongiorno/completa-dati?pt=${obj.istant_win.play_token}&pm=${obj.istant_win.play_interface}">Richiedi premio</a>`;

        let prizeRequestDone = `
                     <span class="content-feedback">
                        Hai già richiesto<br/>il tuo premio
                    </span>`;

        let html = `<div class="recap-row-feedback">${obj.istant_win.prize_request.requested > 0 ? prizeRequestDone : prizeRequestToDo}</div>`;

        return obj.istant_win.win_status == 'WIN' || obj.istant_win.win_status == 'FINAL' ? html : '' ;
    }

    removeLoader(){
        $('.tool_loader').fadeOut(500).remove();
        $('body').removeClass('noScroll');
    }

    startLoader(){
        $('.mb-promo-fette-2019').append('<div data-tool-loader="" class="tool_loader"><svg><use xlink:href="#svg_loader"></use></svg></div>');
        $('body').addClass('noScroll');
    }

}

export default AreaPersonaleCtrl;
